import { IStaticStore, ITimeZones } from '@/interfaces/powerMarkets/IStaticStore.ts';
import { IPlantsStore } from '@/interfaces/powerMarkets/IPlantsStore.ts';
import { IPlantsByCountry } from '@/interfaces/powerMarkets/plant/IPlantsByCountry.ts';
import { IDefinitionSearchInfo } from '@/interfaces/powerMarkets/static/IDefinitionSearchInfo.ts';
import { useApi, ApiPromise, TApiBaseUrlKey } from '@/api/useApi.ts';
import { IEarliestDateInBuffer } from '@/interfaces/powerMarkets/static/IEarliestDateInBuffer.ts';
import { authState } from '@lcp/http-auth';
import { IPeriodData } from '@/interfaces/powerMarkets/balancing/IDatePeriod.ts';
import { parseStaticApiOverrides } from './staticApiOverrides.ts';

const apiStaticCall = useApi('static');
const apiCall = useApi();
const apiDynamicCall = useApi('dynamic');

function getStaticStore (): ApiPromise<IStaticStore> {
    return apiStaticCall.post<{ website: 'Enact'; apiEndpointOverrides: Record<string, string> }, IStaticStore>({
        endpoint: '/staticStore',
        payload: {
            website: 'Enact',
            apiEndpointOverrides: parseStaticApiOverrides(import.meta.env.VITE_APP_STATIC_API_OVERRIDES),
        },
    });
}

function getPlantStore (): ApiPromise<IPlantsStore> {
    const api = authState.value.loggedIn ? apiCall : apiStaticCall;
    return api.get<IPlantsStore>({
        endpoint: '/plantStore',
    });
}

function getPlantByEndpointKey (endpointKey: TApiBaseUrlKey): ApiPromise<IPlantsByCountry> {
    const enactEuropeCall = useApi(endpointKey);

    return enactEuropeCall.get<IPlantsByCountry>({
        endpoint: '/Plant',
    });
}

function getSearchDefinitions (): ApiPromise<Array<IDefinitionSearchInfo>> {
    return apiStaticCall.get<Array<IDefinitionSearchInfo>>({
        endpoint: '/Definitions/Search',
    });
}

function getTimeZones (): ApiPromise<ITimeZones> {
    return apiStaticCall.get<ITimeZones>({
        endpoint: '/timeZone/timeZones',
    });
}

function getPeriodData (): ApiPromise<IPeriodData> {
    return apiStaticCall.get<IPeriodData>({
        endpoint: '/tradingperiod',
    });
}

function getEarliestDateInBuffer (endpoint: string): ApiPromise<IEarliestDateInBuffer> {
    return apiDynamicCall.get<IEarliestDateInBuffer>({
        endpoint: `${endpoint}/EarliestDateInBuffer`,
    });
}

export const dataStoreApi = {
    getPlantByEndpointKey,
    getPlantStore,
    getSearchDefinitions,
    getStaticStore,
    getTimeZones,
    getPeriodData,
    getEarliestDateInBuffer,
};
